// extracted by mini-css-extract-plugin
export default {"-large":"zevCC9ZtHgzl3wtTKgyK","fadeIn":"Ht4igHsBedImJ0MVDoRi","wrapperClasses":"OA9UorKlagCk3nVCXIhn"};